// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import { customs } from 'app_config/globals'
import Swal from 'sweetalert2'
// @end

// @import components
import {CourseSchedulingModuleLayout} from 'app_components/modules/admin/courseScheduling/form'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import CourseSchedulingService from 'app_services/admin/courseScheduling/courseSchedulingService'
import ReactSelectService from 'app_services/components/reactSelectService'
import DurationFieldService from 'app_services/components/durationFieldService'
// @end

// @import types
// @end

// @ADD Component types
interface ICourseSchedulingModuleProps {
  onHandleSubmit?: (data: any) => void
  editData?: any
  viewer: boolean
}
interface ICourseSchedulingModuleState {
  customErrors: any
  processing: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CourseSchedulingModule extends Component<ICourseSchedulingModuleProps, ICourseSchedulingModuleState> {

  private durationFieldService: DurationFieldService
  private reactSelectService: ReactSelectService
  private courseSchedulingService: CourseSchedulingService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICourseSchedulingModuleProps) {
    super(props)
    this.state = {
      customErrors: null,
      processing: false,
    }

    this.reactSelectService = new ReactSelectService()
    this.courseSchedulingService = new CourseSchedulingService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
    this.durationFieldService = new DurationFieldService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onSubmit = async (data: any) => {

    this.setState({processing: true, customErrors: null})

    let customErrors: any = {}
    if (data.duration) {
      data.duration = this.durationFieldService.getSecondsFromDuration(data.duration)
      if (data.duration === 0) {
        customErrors['duration_invalid'] = this.i18nUtil.getTranslate('modules.course_scheduling.duration_invalid')
      }
    }

    if (!!data.typeCourse && data.serviceValidity) {
      data.serviceValidity = this.durationFieldService.getSecondsFromDuration(data.serviceValidity)
      if (data.serviceValidity === 0) {
        customErrors['service_validity_invalid'] = "Este campo es requerido"
      }
    }

    if (data.serviceValidity) {
      if (typeof data.serviceValidity !== 'number') {
        data.serviceValidity = this.durationFieldService.getSecondsFromDuration(data.serviceValidity)
      }
      if (data.serviceValidity === 0) {
        customErrors['service_validity_invalid'] = this.i18nUtil.getTranslate('errors.this_field_is_required')
      }
    } else {
      data.serviceValidity = 0
    }

    if (data?.schedulingStatus?.label === "Confirmado" && data?.serviceType?.value === 'withoutTutor') {
      // TODO: Deshabilitado temporalmente mientras se activa pasarela. Aún no lo requiere, los servicios actuales se certifican con plugin en el aula.
      // if (!data?.certificate_students || data?.certificate_students === false || typeof data?.certificate_students !== 'boolean') {
      //   customErrors['certificate_students_required'] = `El servicio requiere la configuración de certificación para estudiantes`
      // }
      // TODO: Deshabilitado temporalmente mientras se activa pasarela. Aún no lo requiere.  La certificación actualmente se emite a través de plugin en el aula.
      // if (!data?.hasMultipleCertificate || data?.hasMultipleCertificate === false) {
      //   customErrors['hasMultipleCertificate_required'] = `El servicio requiere la configuración de múltiples certificaciones`
      // }
      // if ((!data?.hasCost || data?.hasCost === false) || (!data?.priceCOP || data?.priceCOP === "" || parseInt(data.priceCOP) <= 0)) {
      //    customErrors['cost_required'] = `El servicio debe tener configurado un precio válido`
      // }
    }
    // @INFO: Si existen campos con error retorno
    if (Object.keys(customErrors).length > 0) {
      this.setState({processing: false, customErrors})
      return false
    }

    if (data.schedulingType && data.schedulingMode) {

    }

    data['regional_transversal'] = null
    if (data.schedulingMode) {
      if (data.schedulingMode?.label === 'Virtual') {
        data['regional_transversal'] = customs.regional_transversal
      } else if (['Presencial - En linea', 'Presencial', 'En linea'].includes(data.schedulingMode?.label)) {
        if (data.schedulingType) {
          if (data.schedulingType?.label === 'Abierto') {
            data['regional_transversal'] = customs.regional_transversal
          }
        }
      }
    }

    // if (data.schedulingMode) data.schedulingMode = this.reactSelectService.formatReactSelectResponse(data.schedulingMode)
    if (data.auditor_modules) {
      data.auditor_modules = this.reactSelectService.formatReactSelectResponse(data.auditor_modules)
      data.auditor_modules = data.auditor_modules.join(',')
    }
    if (data.client) data.client = this.reactSelectService.formatReactSelectResponse(data.client)
    if (data.modular) data.modular = this.reactSelectService.formatReactSelectResponse(data.modular)
    // if (data.program) data.program = this.reactSelectService.formatReactSelectResponse(data.program)
    if (data.schedulingType) data.schedulingType = this.reactSelectService.formatReactSelectResponse(data.schedulingType)
    if (data.schedulingStatus) data.schedulingStatus = this.reactSelectService.formatReactSelectResponse(data.schedulingStatus)
    // if (data.course) data.course = this.reactSelectService.formatReactSelectResponse(data.course)
    // if (data.teacher) data.teacher = this.reactSelectService.formatReactSelectResponse(data.teacher)
    if (data.account_executive) data.account_executive = this.reactSelectService.formatReactSelectResponse(data.account_executive)
    if (data.regional) data.regional = this.reactSelectService.formatReactSelectResponse(data.regional)
    if (data.city) data.city = this.reactSelectService.formatReactSelectResponse(data.city)
    if (data.country) data.country = this.reactSelectService.formatReactSelectResponse(data.country)
    if (data.material_assistant) data.material_assistant = this.reactSelectService.formatReactSelectResponse(data.material_assistant)
    if (data.contact) data.contact = this.reactSelectService.formatReactSelectResponse(data.contact)
    if (!data.reprograming || (data.reprograming && data.reprograming === "")) data.reprograming = undefined
    if (data.serviceType) {
      data.serviceType = this.reactSelectService.formatReactSelectResponse(data.serviceType)
      data[data.serviceType] = true
    } else {
      data.withoutTutor = false
      data.quickLearning = false
    }

    // console.log('onSubmit-data', data)
    // this.setState({processing: false, customErrors: null})
    // return false;

    data['sendEmail'] = true

    const newData = new FormData();
    data = Object.keys(data).reduce((accum: FormData, key) => {
      if (data[key]) {
        if (key !== 'icon_1_file' && key !== 'icon_2_file' && key !== 'signature_1_file' && key !== 'signature_2_file' && key !== 'signature_3_file') {
          newData.append(key, typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key] );
        } else if (data[key][0]) {
          newData.append(key, data[key][0] );
        }
      }
      return accum;
    }, new FormData());

    data = newData;

    Swal.fire({
      title: `${this.props?.editData?._id ? 'Actualizando' : 'Creando'} servicio`,
      html: 'Por favor espere mientras el proceso termina...',
      allowOutsideClick: false,
      onBeforeOpen: () => {
          Swal.showLoading()
      },
    });

    const courseResponse = await this.courseSchedulingService.insertOrUpdate(
      data,
      (this.props.editData && this.props.editData._id) ? `update/${this.props.editData._id}` : 'create'
    )

    console.log({ courseResponse })

    if (courseResponse) {
      Swal.close();
      const serviceId = courseResponse?.metadata?.service_id;
      await Swal.fire(
        `Servicio ${this.props?.editData?._id ? 'Actualizado' : 'Creado'} con éxito`,
        `Identificador del servicio: ${serviceId}`,
        'success'
      )
      // let screen_notification_label = 'components.screen_notifications.add'
      // if (this.props.editData && this.props.editData._id) {
      //   screen_notification_label = 'components.screen_notifications.update'
      // }

      // this.screenNotifications.fireToast(
      //   {
      //     message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
      //   },
      //   {
      //     position: 'bottom-right',
      //   }
      // )

      if (this.props.onHandleSubmit) {
        this.props.onHandleSubmit(courseResponse)
      }
    }

    this.setState({ processing: false })
  }

  render() {
    return(
      <CourseSchedulingModuleLayout
        processing={this.state.processing}
        editData={this.props.editData}
        onHandleSubmit={this.onSubmit}
        customErrors={this.state.customErrors}
        viewer={this.props.viewer}
      />
    )
  }
}

export default connect(mapStatesToProps)(CourseSchedulingModule)
